
    import { Component, Vue, Prop, Watch } from 'vue-facing-decorator';

    @Component({
        emits: ['save'],
    })
    export default class CloneScenario extends Vue {
        @Prop({ default: null }) public scenario: any;

        private modalShow = false;
        // Getter, not a field: a field-initializer arrow captures the raw `this` (no `$t`).
        private get nameRules() { return [(value: any) => !!value || this.$t("message.scenarioNameIsRequired")]; }

        private mounted() {
            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape") {
                    if (this.modalShow) this.close();
                }
            });
        }

        @Watch('scenario')
        private onScenarioChanged(value: any) {
            if (value) this.modalShow = true;
            else this.modalShow = false;
        }

        private async close() {
            const res = await this.$confirm(String(this.$t('message.confirmClose')), { buttonTrueText: String(this.$t('message.yes')), buttonFalseText: String(this.$t('message.no')) });
            if (res) { this.modalShow = false }
        }

        private submit() {
            const valid = (this.$refs.form as any).validate();
            if (valid) {
                this.modalShow = false;
                this.$emit('save', this.scenario);
            }
        }
    }
